import { axios } from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchReleaseNotes(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/release_notes', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
